<script setup lang="ts">
import {Dialog} from "@/core/components/ui/dialog";
import {computed, ref} from "vue";
import ContestForm from "@/contest/components/ContestForm.vue";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";

const props = defineProps<{
    contestId: number;
    open?: boolean;
}>();

const emits = defineEmits(['on-refresh', 'update:open']);

const modalOpen = computed({
    get: () => props.open ?? false,
    set: (value) => emits('update:open', value)
});

const fetching = ref(false);
</script>

<template>
  <Dialog v-model:open="modalOpen">
    <BaseFlexSpinner v-if="fetching" />
    <ContestForm
      v-else
      :contest-id="contestId"
      :edit="false"
      :open-state="modalOpen"
      @on-refresh="emits('on-refresh')"
      @update:open="emits('update:open', $event)"
    />
  </Dialog>
</template>

